import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const inventory = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return new Promise((resolve, reject) => {
      inventory
        .get("/inventories?" + qstr)
        .then((res) => {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              res.data.data.map((el) => {
                el.created_at = fx.formatDateTime(
                  el.created_at,
                  this.$store.getters.timezone
                );
              });
            } else {
              if (res.data.data.data && res.data.data.data.length > 0) {
                res.data.data.data.map((el) => {
                  el.created_at = fx.formatDateTime(
                    el.created_at,
                    this.$store.getters.timezone
                  );
                });
              }
            }
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getListProducts() {
    return inventory.get("/inventories");
  },
  updateProductQuantity(list) {
    let data = {
      products: list,
    };
    return inventory.put("/inventories/products", data);
  },
  getSingleProduct(sku) {
    return inventory.get("/inventories/products/" + sku);
  },
  find(id) {
    return inventory.get("/inventories/" + id);
  },
  create(inputs) {
    return inventory.post("/inventories", inputs);
  },
  update(id, inputs) {
    return inventory.put("/inventories/" + id, inputs);
  },
  delete(id) {
    return inventory.delete("/inventories/" + id);
  },
  getAllSettings() {
    return inventory.get("/inventories/settings");
  },
  updateSettings(data) {
    return inventory.put("/inventories/settings", data);
  },
  getProductFromWareHouse(page, limit, keyword) {
    return inventory.get(
      "/inventories/products?page=" + page + "&limit=" + limit + "&q=" + keyword
    );
  },
  getInventoryWarehouse() {
    return inventory.get("/inventories/warehouses");
  },
};
